// Form options
export const EVENT_BUDGET_CHOICES = [
  "$6,000 - $8,000",
  "$8,000 - $12,000",
  "$12,000 - $24,000",
  "$24,000+",
];

export const EVENT_TYPE_CHOICES = [
  "Corporate Gatherings",
  "Workshops",
  "Launches (Product, Brand, etc.)",
  "Boardroom",
  "Training, Work Sessions, Team Buildings",
  "Personal Event",
  "Corporate Entertaining",
  "Other",
];
